<template>
  <ConfirmDialog group="already_connected_shop">
    <template #container="{ acceptCallback, rejectCallback }: { message: ConfirmationOptions, acceptCallback: () => void, rejectCallback: () => void }">
      <BaseDialogFrame
        closeable
        :header="shop_name + ' is already connected to your eRank account'"
        header-class="v3-regular-medium-line-height-150 text-[--text-primary]"
        @close="rejectCallback"
      >
        <template #body>
          <p class="text-small-normal">
            If you’d like to connect a different Etsy shop, make sure you’re logged into the <span class="text-small-semi-bold">correct Etsy seller account</span> first, then try again.
          </p>
        </template>

        <template #footer>
          <Button label="Connect My Shop" class="mt-[8px]" @click="acceptCallback" />
        </template>
      </BaseDialogFrame>
    </template>
  </ConfirmDialog>
</template>

<script lang="ts" setup>
import { useUrlSearchParams } from '@vueuse/core';
import Button from 'primevue/button';
import type { ConfirmationOptions } from 'primevue/confirmationoptions';
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from 'primevue/useconfirm';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

import BaseDialogFrame from '@/common/components/molecules/BaseDialogFrame';
import { mixPanelEvents } from '@/common/constants';
import { useEtsyMarketplaceStore } from '@/common/stores/marketplaces';
import { track } from '@/helpers/analytics/mixpanel';

const props = withDefaults(defineProps<Props>(), {
  redirectTo: 'dashboard',
});
const route = useRoute();
const page_slug = route.meta?.metaTags?.find((tag) => tag.page_slug)?.page_slug ?? '';
const source = page_slug.replaceAll(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());

const confirm = useConfirm();
const etsyStore = useEtsyMarketplaceStore();
const params = useUrlSearchParams('history');

const shop_name = params.shop_name ?? '';

interface Props {
  redirectTo?: string
}

onMounted(() => {
  if(params.already_connected == 'true' && params.shop_name) {
    confirm.require({
      header: 'Shop Already Connected',
      group: 'already_connected_shop',
      accept: () => (etsyStore.connectShop('etsy', props.redirectTo), track(mixPanelEvents.STARTED_SHOP_CONNECTION, {
        'Source': source,
        'Connection Type': 'Etsy Shop',
        'Erank Version': 3,
      })),
      reject: () => window.location.href = `/${props.redirectTo}`,
    });
  }
});
</script>
